import { Tabs } from "@metacrm/metacrm-material-ui/dist/Tabs";
import React, { useEffect, useState } from "react";
import General from "./General";
import Customization from "./Customization";
import Code from "./Code";
import { useOutletContext } from "react-router";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { Loading } from "features/common";
import axios from "axios";
import { apiUrl } from "features/configure";
import Back from "features/metadesk/components/Back";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import { isVersionLessThan } from "features/helpers/utils";
import { Link } from "react-router-dom";
import { selectWebsiteOptIn } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { useSelector } from "react-redux";
import useNavigateEntity from "hooks/useNavigateEntity";
import useDiscardConfirm from "../../hook/useDiscardConfirm";

export default function IntegrationOptInSetting() {
  const dispatchSnackbar = useDispatchSnackbar();
  const [entityName] = useOutletContext();
  const [data, setData] = useState({});
  const [integrityInfo, setIntegrityInfo] = useState({});
  const [tabsValue, setTabsValue] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [nextTabValue, setNextTabValue] = useState(tabsValue);

  const [hasChanges, setHasChanges] = useState(false);
  const [hasSaved, setHasSaved] = useState(false);
  const { handleDiscardConfirm, resetIsConfirmed, isConfirmed } =
    useDiscardConfirm();

  const handleChange = (event, newValue) => {
    if (hasChanges) {
      setNextTabValue(newValue);
      handleDiscardConfirm();
    } else {
      setTabsValue(newValue);
    }
  };

  useEffect(() => {
    if (isConfirmed) {
      setTabsValue(nextTabValue);
      setHasChanges(false);
      resetIsConfirmed();
    }
  }, [isConfirmed]);

  const handleFetchOptInDetail = async () => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(
        `${apiUrl}/api/manage/websiteOptInConfig/${entityName}`
      );
      console.log("data: ", data);
      setData(data);
    } catch (err) {
      dispatchSnackbar({ err });
    } finally {
      setIsLoading(false);
    }
  };
  const websiteOptIn = useSelector(selectWebsiteOptIn);
  const { latestVersion } = websiteOptIn || {};

  const fetchIntegrity = async () => {
    try {
      const { data } = await axios.get(`${apiUrl}/api/integrity/websiteOptIn`);
      setIntegrityInfo(data);
    } catch (err) {
      dispatchSnackbar({ err });
    }
  };

  const { formatMessage } = useIntl();
  useEffect(() => {
    handleFetchOptInDetail();
    fetchIntegrity();
  }, []);

  const tabs = [
    {
      label: formatMessage({ id: "global.category.general" }),
      content: (
        <General
          data={data}
          handleRefetch={handleFetchOptInDetail}
          setHasChanges={setHasChanges}
          hasSaved={hasSaved}
          setHasSaved={setHasSaved}
        />
      ),
      _id: 1,
    },
    {
      label: formatMessage({ id: "global.tab.customization" }),
      content: (
        <Customization
          data={data}
          handleRefetch={handleFetchOptInDetail}
          setHasChanges={setHasChanges}
          hasSaved={hasSaved}
          setHasSaved={setHasSaved}
        />
      ),
      _id: 2,
    },
    {
      label: formatMessage({ id: "global.tab.apiCode" }),
      content: (
        <Code
          data={data}
          handleRefetch={handleFetchOptInDetail}
          integrityInfo={integrityInfo}
        />
      ),
      _id: 3,
    },
  ];

  const canUpdate = isVersionLessThan(
    data?.jsVersion || latestVersion,
    latestVersion
  );
  const { navigateEntity } = useNavigateEntity();

  return (
    <Box sx={{ position: "relative", minHeight: "100vh" }}>
      <Back />
      <div className="fade-up">
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <div className="title">
            {formatMessage({ id: "integration.subscribeBtn.name" })}
          </div>
          {canUpdate && (
            <Box
              fontSize={12}
              ml="12px"
              sx={{ display: "flex", alignItems: "center" }}
            >
              v{latestVersion} -
              <Box
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  ml: "4px",
                  color: "#7B61FF",
                }}
                onClick={() => {
                  navigateEntity(
                    "/settings/general/app/update-list?updateType=websiteOptIn"
                  );
                }}
              >
                {formatMessage({ id: "general.btn.updateNow" })}
              </Box>
            </Box>
          )}
        </Box>
        <div className="description" style={{ marginBottom: "22px" }}>
          {formatMessage({ id: "websiteOptIn.update.description" })}
        </div>
      </div>

      {isLoading ? (
        <Loading open={true} fullScreen={false} />
      ) : (
        <div className="fade-up-more">
          <Tabs tabs={tabs} value={tabsValue} onChange={handleChange} />
        </div>
      )}
    </Box>
  );
}
